module.exports = __webpack_public_path__ + "static/img/payment.86ed1fd7.jpeg";